import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSort} from '@angular/material/sort';
import { MatTableDataSource} from '@angular/material/table';
import { TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { Router } from '@angular/router';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { Observable } from 'rxjs';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
import {SelectionModel} from '@angular/cdk/collections';
import { Clipboard } from "@angular/cdk/clipboard"
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
  selector: 'app-task3c-tasklists',
  templateUrl: './task3c-tasklists.component.html',
  styleUrls: ['./task3c-tasklists.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})


export class Task3CTaskListsComponent implements OnInit {

  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  taskList:any=[]=[];
  subTaskList:any=[]=[];

  value:string = '';
  showCreateTask: boolean = false;
  showTaskDetail: boolean = false;
  showProcess: boolean = false;
  showmyDrive:boolean = true;
  showSub:boolean = false;
  showSub1:boolean = false;  

  dataSource: any=[]=[];
  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  displayedColumns: string[] = [];

  pageSizeOptions: number[] = [10, 20, 50, 100];
  paginatorTotalLength:any;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  

  taskId:number=0;

  taskListFolder:any=[]=[];
  selection = new SelectionModel<any>(true, []);
  taskStatusList:any=[]=[];

 
  dueDatetext: string='Due Date';
  myTaskText:string='Task';
  preorityArray: any=[];
  isOverDue: boolean=false;
  isDuedate: boolean=false;
  dateFrom: any=null;
  dateTo: any=null;
  preoritytext: string="Priority";
  IsAssignedToMe: boolean=false;
  IsAssignedToMyRole: boolean=false;
  IsAllTask: boolean=false;
  IsCreatedByMe: boolean=false;
  isMyTaskFilterSelected: boolean=false;
  completedTaskStatusID: any=0;
  @Input() modulename: string;
  @Input() mainModulename: string;
  @Input() transactionID: number=0;
  @Input() typeId: number=0; 
  @Output() closeTaskList = new EventEmitter<boolean>();


  @Input() name: string=""; 
  @Input() email: string=""; 
  @Input() imageUrl: string=""; 
  @Input() entityId: number=0; 
  @Input() TypeIdDrp: number=0; 

  taskListArchived = [
    {
      id: 1,
      name: "TaskList",     
    },
    {
      id: 2,
      name: "Single Task",     
    },
  ];

  constructor(private dialog: MatDialog, private loaderService: LoaderService,
    private cdr: ChangeDetectorRef, private _dataSharingService: DataSharingService, 
    private router: Router,private reusableClass: ReusableClasses,
    private encryptionAlgo: EncryptionService,private statusConst: StatusConstant,      
    private taskService: SettingService,private formBuilder: FormBuilder,  private coreService: CoreService,
    private toastr: ToastrService,private clipboard: Clipboard){
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    }
 
   ngOnChanges(changes: SimpleChanges) {
      this.modulename;
      this.mainModulename;
      this.transactionID;
      this.typeId;
      this.transactionIDForTask= this.transactionID;
      this.typeIdForTask =this.typeId;    
   }
   
  ngOnInit(): void {  
    this.gettaskls();
  }

  gettaskls(){ 
    var ReqModel={
       folderID:0,
       transaction: {
        transactionID: this.transactionID,
        typeId: this.typeId
       },
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID:Number(this.databaseId),
    }      
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskLists = response.data.taskLists;    
          this.loaderService.hide();           
        }
        else {
          this.taskLists=[];
          this.loaderService.hide();
        }
      }
      else { 
        this.taskLists=[];
        this.loaderService.hide();
      }
    });
  }
      
  closeTemplate(){
    this.taskListFolderID=0;
    this.selectedTaskCategoryID=0;
    this.searchTemplateName="";
    this.dialog.closeAll();
  } 
  
  close() {
    this.taslTemplateID=0;
    this.myfolderForm.reset();
    this.taskListFolderID=0;
    this.taskListID=0;
    this.dialog.closeAll();  
  }

  closeTasksList(){
    this.taslTemplateID=0;   
    this.taskListFolderID=0;
    this.taskListID=0;
    this.closeTaskList.emit(false);
  }

  
  assignUser(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'selectParticipants',
    });
  }

  renameFile(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef);
  }

  taskComplete:boolean = false;
  selectedTaskOption: any
  showAssignedTask = false;
  showReminderTask = false;
  showScheduleTask = false;
  showAttachTask = false;
 
  showTaskLists:boolean=false;

  //================For Left Side Panel  TaskFolder ========================//

 
  folderortask:string="";
  folderTaskName:string="";

  myfolderForm: FormGroup; 
  addTemplateForm: FormGroup;
  spinner:boolean=false;
  taskListFolderID:number=0;
  taskListID:number=0;
  taskLists:any=[]=[];
  expandedIndex:number=0;
  expandedIndexmoveTo:number=0;

  getTaskListFolders() {
    this.loaderService.show();
    var ReqModel={
       userID: this.currentUser.UID,     
       officeID: this.myOfficeID,    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID:Number(this.databaseId),  
    }     
    this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskListFolder = response.data.taskListFolders;          
        }
        else {        
          this.taskListFolder=[];             
          this.loaderService.hide();
        }
      }
      else {       
        this.taskListFolder=[];
        this.loaderService.hide();
      }
    });
  }

  
  addFolder(templateRef: TemplateRef<any>,folderortask:any,tasklist:any) {
    this.taskListFolderID=0;
    this.taskListID=0;
    this.taslTemplateID=0;
    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask =folderortask;
    if(this.folderortask.toLowerCase()=="folder"){
      this.folderTaskName="Folder";
    }else{
      this.folderTaskName="Task List";
      this.getTaskTemplates();
    } 
    if(tasklist!=""){
      this.taskListFolderID=tasklist.taskListFolderID;
    }
    this.dialog.open(templateRef);
  }


  addTaskListButton:boolean=false;
  TaskListName:string="";
  taskCategoryList: any[]=[];  
  selectedTaskCategoryID:number=0;

  addTaskListTemp(templateRef: TemplateRef<any>,tasklist:any,index:number){
    this.addTaskListButton=false;
    this.TaskListName="";
    this.searchTemplateName="";

    this.expandedIndex=index;

    this.taskListFolderID=0;
    this.taskListID=0;
    this.taslTemplateID=0;

    this.selectedTaskCategoryID=0;

    this.getTaskTemplates();

    this.taskListFolderID=tasklist.taskListFolderID;
    
    this.getActiveTaskTemplateCategories();

    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });  
  }

  addTaskListTempForTaskList(templateRef: TemplateRef<any>){
    this.addTaskListButton=false;
    this.TaskListName="";
    this.searchTemplateName="";

    this.expandedIndex=0;

    this.taskListFolderID=0;
    this.taskListID=0;
    this.taslTemplateID=0;

    this.selectedTaskCategoryID=0;

    this.getTaskTemplates();

    this.taskListFolderID=0;//tasklist.taskListFolderID;
    
    this.getActiveTaskTemplateCategories();

    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });  
  }


  getActiveTaskTemplateCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,     
      officeIDList: this.OfficeIDList,
      databaseID:Number(this.databaseId)
    }    
    this.taskService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
  }

  onTaskListNameChange(searchValue: string): void {  
    if(searchValue.trim()==""){
      this.addTaskListButton=false;
    }else{
      this.TaskListName=searchValue.trim();
      this.addTaskListButton=true;
    }
  }

  
  SelectTemplateForAddTaskList(temp:any){
   this.taslTemplateID=temp.taskTemplateID;
  }

  getSelectTaskCategory(e:any){
    this.taskTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

   this.selectedTaskCategoryID=e.value;
   this.getTaskTemplates();
  }

 async addTaskLists(){
  this.loaderService.show();
  var ReqModel={     
    taskListID:0,
    taskListName: this.TaskListName,
    position:0,
    folderID: this.taskListFolderID,
    taskTemplateID:this.taslTemplateID,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),      
    officeID: this.myOfficeID,
    officeIDList: this.OfficeIDList,
    templateCreatedUserID: this.currentUser.UID,
    templateCreatedOrganizationID: Number(this.organizationId),
    templateCreatedOfficeID: this.myOfficeID,     
  }
 // return;
  this.spinner=true;
  this.addTaskListButton=false;  
  const result = await this.taskService.addTaskList(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner=false;     
    this.loaderService.hide();
    this.getTaskListFolders();
    var obj={
      taskListFolderID:this.taskListFolderID
    }
    this.getTaskLists(obj,this.expandedIndex);
    this.taslTemplateID=0;
    this.toastr.success("Task list created successfully.", '', {
      timeOut: 3000,
    });
    this.closeTemplate();
  }
  else {
    this.toastr.error("Task list creation failed.", '', {
      timeOut: 3000,
    });
    this.spinner=false;
    this.loaderService.hide(); 
  } 
 }



  updateFolder(templateRef: TemplateRef<any>,folderortask:any,tasklist:any) {
    this.taskListFolderID=0;
    this.taskListID=0;
    
    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask =folderortask;
    if(this.folderortask.toLowerCase()=="folder"){
      this.folderTaskName="Folder";
      this.taskListFolderID=tasklist.taskListFolderID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListFolderName); 
    }else{
      this.folderTaskName="Task List";
      this.taskListID=tasklist.taskListID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListName); 
    }     
    this.dialog.open(templateRef);
  }

  taskListFolderIDForUpdate:number=0;

  updateTaskLists(templateRef: TemplateRef<any>,folderortask:any,tasklist:any) {
    this.taskListFolderID=0;
    this.taskListID=0;

    let group = {};
    this.myfolderForm = new FormGroup(group);
    this.createTaskFolder();
    this.folderortask =folderortask;
    if(this.folderortask.toLowerCase()=="folder"){
      this.folderTaskName="Folder";
      this.taskListFolderID=tasklist.taskListFolderID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListFolderName); 
    }else{
      this.folderTaskName="Task List";
      this.taskListID=tasklist.taskListID;
      this.myfolderForm.controls['folderName'].setValue(tasklist.taskListName); 
    }     
    this.dialog.open(templateRef);
  }

  createTaskFolder(): void {
    this.myfolderForm = this.formBuilder.group({
     folderName: ['', [Validators.required]]    
    },);
  } 

  createSaveAsTaskTemplate(): void {
    this.addTemplateForm = this.formBuilder.group({
      taskTemplateName: ['', [Validators.required]],
      folderID: ['', [Validators.required]],
    },);
  } 

  async addTaskListFolder(data){
    if(this.taskListFolderID==0){
     this.addtaskListFolders(data);
    }  
  }

  taslTemplateID:number=0;
  

  OnSelectTempChange(taslTemplateID) {
    this.taslTemplateID=taslTemplateID.value;   
   }
     
  async addtaskListFolders(data){
  this.loaderService.show();
  var ReqModel={     
    folderName: data.folderName,
    colourCode: 0,
    position:0,
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),      
    officeID: this.myOfficeID,
    officeIDList: this.OfficeIDList    
  }
  this.spinner=true;  
  this.myfolderForm.markAsPristine();
  const result = await this.taskService.addTasklistFolder(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner=false;     
    this.loaderService.hide();
    this.taskLists=[];
    this.getTaskListFolders();
    this.toastr.success("Task folder created successfully.", '', {
      timeOut: 3000,
    });
    this.close();
  }
  else {
    this.toastr.error("Task folder creation failed.", '', {
      timeOut: 3000,
    });
    this.spinner=false;
    this.loaderService.hide(); 
  } 
  }

 
  currentTaskList: number = 0;  
  taskListSelected = false;

  getTaskLists(tasklist:any,index:number) {   
    if(this.currentTaskList == index){      
      this.taskListSelected = !this.taskListSelected;
    }else{
      this.taskListSelected = true;
    }    
   
    this.currentTaskList = index;

    this.selectedRecordMoveToArray=[];
    this.selection.clear();  
    this.showMoveToOption=false;  
    this.taskLists=[];
    this.expandedIndex=index;
    this.dueDatetext='Due Date';
    this.preoritytext="Priority";
    this.myTaskText="Task";
    this.taskListFolderID=tasklist.taskListFolderID;
    var ReqModel={
       folderID:tasklist.taskListFolderID,
       transaction: {
        transactionID: this.transactionID,
        typeId: this.typeId
       },
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID:Number(this.databaseId),
    }      
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskLists = response.data.taskLists;       
          this.loaderService.hide();          
        }
        else {
          this.taskLists=[];
          this.loaderService.hide();
        }
      }
      else { 
        this.taskLists=[];
        this.loaderService.hide();
      }
    });
  }
  

  getTaskLists1(tasklist:any,index:number) {

    if(this.currentTaskList == index){      
      this.taskListSelected = !this.taskListSelected;
    }else{
      this.taskListSelected = true;
    }
   
    this.currentTaskList = index;

    this.selectedRecordMoveToArray=[];
    this.selection.clear();   
    this.showMoveToOption=false;  
    this.expandedIndex=index;
    this.dueDatetext='Due Date';
    this.preoritytext="Priority";
    this.myTaskText="Task";
    this.taskListFolderID=tasklist.taskListFolderID;    
  }

  //== For Delete Task List Folder ====//
  deleteTasklistFolder(tasklistfolder) {
    const message = `Are you sure you want to delete this task list folder?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {          
          var reqModel={
            taskListFolderID: tasklistfolder.taskListFolderID,          
            userID: this.currentUser.UID,  
            officeID: this.myOfficeID,    
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId),
          }          
          this.loaderService.show();
          this.taskService.removeTasklistFolder(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
                this.taskLists=[];
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list folder deleted successfully.', '', {
                  timeOut: 3000,
                });
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list folder deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list folder deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }
  
   //== For Delete Task List ====//
  deleteTasklist(tasklist:any,) {//index:number,tasklistfolder:any
    const message = `Are you sure you want to delete this task list?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);  
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {          
          var reqModel={
            taskListID: tasklist.taskListID,          
            userID: this.currentUser.UID,  
            officeID: this.myOfficeID,    
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID:Number(this.databaseId),
          } 
          //this.expandedIndex=index;    
          this.loaderService.show();
          this.taskService.removeTasklist(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) { 
                this.taskLists=[];           
                this.getTaskListFolders();
                this.loaderService.hide();
                this.toastr.success('Task list deleted successfully.', '', {
                  timeOut: 3000,
                });                
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list deletion failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list deletion failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  // Update  Task List folder //
  async UpdateTaskListFolder(data){
    if(this.taskListFolderID>0){   
      this.updatetaskListFolders(data);
     }
     if(this.taskListID>0){
      this.updateTaskList(data);
     }
  }

   //== For rename Task List folder ====//
  async updatetaskListFolders(data){
  this.loaderService.show();
  var ReqModel={
    taskListFolderID: this.taskListFolderID,
    taskListFolderName: data.folderName,  
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),      
    officeID: this.myOfficeID,
    officeIDList: this.OfficeIDList    
  }
  this.spinner=true;  
  this.myfolderForm.markAsPristine();
  const result = await this.taskService.renameTasklistFolder(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner=false;     
    this.loaderService.hide();
    this.getTaskListFolders();
    this.toastr.success("Task folder update successfully.", '', {
      timeOut: 3000,
    });
    this.close();
  }
  else {
    this.toastr.error("Task folder update failed.", '', {
      timeOut: 3000,
    });
    this.spinner=false;
    this.loaderService.hide(); 
  } 
  }

     //== For rename Task List ====//
  async updateTaskList(data){
    this.loaderService.show();
    var ReqModel={     
      taskListName: data.folderName,     
      taskListID: this.taskListID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),      
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList    
    }
    this.spinner=true;  
    this.myfolderForm.markAsPristine();
    const result = await this.taskService.renameTasklist(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;     
      this.loaderService.hide();
      this.taskLists=[];
      this.getTaskListFolders();
      var obj={
        taskListFolderID:this.taskListFolderIDForUpdate
      }
      this.getTaskLists(obj,this.expandedIndex);
      this.toastr.success("Task list update successfully.", '', {
        timeOut: 3000,
      });
      this.close();
    }
    else {
      this.toastr.error("Task list update failed.", '', {
        timeOut: 3000,
      });
      this.spinner=false;
      this.loaderService.hide(); 
    } 
  }



   //======Open Task List===========//

   @Output() OpenTaskLists = new EventEmitter();
  isArchived:boolean=false;

   OpenTaskList(Tasklist:any) {  
    this.taskListID=Tasklist.taskListID;
    this.OpenTaskLists.emit(Tasklist);    
  }

  reSetFormURL(taskId:any,formURL:any) {   
    if(formURL!=='' && formURL!=null){
    const getToken = formURL.split("token=")[1];
    if(getToken!==undefined){
    const params = decodeURIComponent(getToken);
    const encrptedToken = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
    const decryptedToken = JSON.parse(encrptedToken)
    decryptedToken.taskID = taskId
    const jsonString = JSON.stringify(decryptedToken)
    const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
    const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
    const finalFormURL = formURL.split("token=")[0] + "token=" + encryptedTokenWithEncoding;
    return finalFormURL;
    }
    return formURL;
  }
  }
  
  
  openTaskListUrl(list,isOpen=false){
    if(list.token!=null && isOpen==false){
      let params=  decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);
      
      decryptedToken.isOpenURL=false;
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);

      let URL = window.location.href.split(window.location.pathname)[0]+"/request/task?token="+encryptedTokenWithEncoding;
      this.clipboard.copy(URL);      
      this.toastr.success("Link Copied.", '', {
        timeOut: 3000,
      });     
   
    }   
    else if(list.token!=null && isOpen==true){
      let params=  decodeURIComponent(list.token);
      const tokenm = this.encryptionAlgo.get(this.reusableClass.encryptionKey, params);
      let decryptedToken = JSON.parse(tokenm);
     
      decryptedToken.isOpenURL=true;
      decryptedToken.email=sessionStorage.getItem('email');
      const jsonString = JSON.stringify(decryptedToken)
      const encryptedToken = this.encryptionAlgo.set(this.reusableClass.encryptionKey, jsonString);
      const encryptedTokenWithEncoding = encodeURIComponent(encryptedToken);
      
      let URL = window.location.href.split(window.location.pathname)[0]+"/request/task?token="+ encryptedTokenWithEncoding;
      window.open(URL, '_blank');
     
    }
  }

 

 selectedRecordMoveToArray: any =[]=[];
 showMoveToOption:boolean=false;
 ButtonForMoveTo:boolean=false;
 taskListIDMoveTo:number=0;
 taskListFolderForMoveTo:any=[]=[];
 taskListsForMoveTo:any=[]=[];
 showAllCheckBoxes = false;


  moveTo(templateRef: TemplateRef<any>) {
    this.taskListIDMoveTo=0;
    this.ButtonForMoveTo=false;
    this.expandedIndexmoveTo=0;
    this.taskListsForMoveTo=[];
    this.getTaskListFoldersForMoveTo();
    this.dialog.open(templateRef);
  }

  getTaskListFoldersForMoveTo() {
    this.loaderService.show();
    var ReqModel={
       userID: this.currentUser.UID,     
       officeID: this.myOfficeID,    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID:Number(this.databaseId),   
    }      
    this.taskService.getTaskListFolders(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskListFolderForMoveTo = response.data.taskListFolders;          
        }
        else {        
          this.taskListFolderForMoveTo=[];             
          this.loaderService.hide();
        }
      }
      else {       
        this.taskListFolderForMoveTo=[];
        this.loaderService.hide();
      }
    });
  }

  getTaskListsForMoveTo(tasklist:any,index:number) {
    this.ButtonForMoveTo=false;
    this.taskListsForMoveTo=[];
    this.expandedIndexmoveTo=index;
    this.loaderService.show();
    var ReqModel={
       folderID:tasklist.taskListFolderID,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID:Number(this.databaseId),
    }      
    this.taskService.getTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskListsForMoveTo = response.data.taskLists;          
        }
        else {
          this.taskListsForMoveTo=[];
          this.loaderService.hide();
        }
      }
      else { 
        this.taskListsForMoveTo=[];
        this.loaderService.hide();
      }
    });
  }

  SelectTaskList(Tasklist:any) {
    if(this.taskListID == Tasklist.taskListID){
      this.toastr.warning('Task can not add same folder.', '', {
        timeOut: 3000,
       });
      return;
    }
    this.taskListIDMoveTo=Tasklist.taskListID;   
    this.ButtonForMoveTo=true;
  }

  MoveToTaskList(){
    var itemList=[];
    if(this.selectedRecordMoveToArray.length>0){
     for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i){
      var obj={
        taskID: this.selectedRecordMoveToArray[i].selectedRecord,
        position: i+1
       }
       itemList.push(obj);
      }
    }
      var ReqModel = {
      taskListID: this.taskListIDMoveTo, 
      tasks: itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,     
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
     };
    this.loaderService.show();
    this.spinner=true;
    this.ButtonForMoveTo=false;
    this.taskService.taskMovetoTaskList(ReqModel).subscribe((response)=>{
      if(response.data == true){
        this.spinner=false;
         this.toastr.success('Task moved successfully.', '', {
          timeOut: 3000,
         });       
         if(this.taskListID == 0){       
        }else{         
        }         
         this.selectedRecordMoveToArray=[];
         this.selection.clear();
      }else{
        this.toastr.error('Task move failed.', '', {
          timeOut: 3000,
         });
        this.spinner=false;
        this.ButtonForMoveTo=false;
      }
    })
  }

  AddTaskTemplateMultiple:Boolean=false;

  SaveAsTemplate(templateRef: TemplateRef<any>,tasklist:any) {
    this.AddTaskTemplateMultiple=false;   
    this.taskListID=tasklist.taskListID;
    let group = {};
    this.addTemplateForm = new FormGroup(group);
    this.createSaveAsTaskTemplate();
    this.getActiveTaskTemplateCategories();
    this.dialog.open(templateRef);
  }

 

  async AddTaskTemplate(data){
    var itemList=[];
    if(this.AddTaskTemplateMultiple==false){
      itemList=null;
    }
    if(this.AddTaskTemplateMultiple==true){
      this.taskListID=0;    
      if(this.selectedRecordMoveToArray.length>0){
       for (var i = 0, len = this.selectedRecordMoveToArray.length; i < len; ++i){
        var obj={
          taskID: this.selectedRecordMoveToArray[i].selectedRecord,
          position: i+1
         }
         itemList.push(obj);
        }
      }
    }

    this.loaderService.show();
    var ReqModel={     
      taskTemplateName: data.taskTemplateName,      
      position:0,
      folderID: data.folderID,
      taskListID: this.taskListID,
      tasks:itemList,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),      
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList    
    }   
    this.spinner=true;  
    this.addTemplateForm.markAsPristine();
    const result = await this.taskService.addTaskTemplate(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;     
      this.loaderService.hide();   
      this.toastr.success("Task template added successfully.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption=false;
      this.selectedRecordMoveToArray=[];
      this.selection.clear();     
    }
    else {
      this.toastr.error("Task template add failed.", '', {
        timeOut: 3000,
      });
      this.showMoveToOption=false;
      this.spinner=false;
      this.loaderService.hide(); 
    } 
   }


   ShowNoRecordFoundTaskTemplates:Boolean=false;
   TaskTemplatesList:any=[]=[];
   taskListIDforAddTemplate:number=0;
 
   
   ShowTemplate(templateRef: TemplateRef<any>,list:any) {  
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.taskListIDforAddTemplate=Number(list.taskListID);
    this.getTaskTemplates();
    this.selectedTaskCategoryID=0;
    this.searchTemplateName="";

    this.taskTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

    this.getActiveTaskTemplateCategories();
  }

  taskTemplateID:number=0;

   SelectTemplate(temp){
    this.taskTemplateID=temp.taskTemplateID;
    // this.loaderService.show();
    // var ReqModel={     
    //   taskListID:this.taskListIDforAddTemplate,
    //   taskListName: "",  
    //   position:0,
    //   folderID: 0,
    //   taskTemplateID:temp.taskTemplateID,
    //   userID: this.currentUser.UID,
    //   organizationID: Number(this.organizationId),
    //   databaseID: Number(this.databaseId),      
    //   officeID: this.myOfficeID,
    //   officeIDList: this.OfficeIDList,
    //   keepAttached: this.AttachChecked,
    //   keepAssignee: this.AssigneeChecked,
    //   keepNotify: this.NotifyChecked,
    // } 
    // this.spinner=true;   
    // const result = await this.taskService.addTaskList(ReqModel).toPromise();
    // if (result.status === this.statusConst.statusSuccess) {
    //   this.spinner=false;     
    //   this.loaderService.hide();
    //   this.getTaskListFolders();
    //   this.taslTemplateID=0;
    //   this.toastr.success("Task Imported successfully.", '', {
    //     timeOut: 3000,
    //   });
    //   this.closeTemplate();
    // }
    // else {
    //   this.toastr.error("Task Import failed.", '', {
    //     timeOut: 3000,
    //   });
    //   this.spinner=false;
    //   this.loaderService.hide(); 
    // } 
  }

  async ImportTemplate(){
    this.loaderService.show();
    var ReqModel={     
      taskListID:this.taskListIDforAddTemplate,
      taskListName: "",  
      position:0,
      folderID: 0,
      taskTemplateID:this.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),      
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: false,//this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    } 
    this.spinner=true;   
    const result = await this.taskService.addTaskList(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;     
      this.loaderService.hide();
      this.getTaskListFolders();
      this.taslTemplateID=0;
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      });
      this.closeTemplate();
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner=false;
      this.loaderService.hide(); 
    } 
  }

  searchTemplateName:string="";

  getTaskTemplates() {
    this.ShowNoRecordFoundTaskTemplates=false;  
    this.loaderService.show();
    var ReqModel={
       folderID:this.selectedTaskCategoryID,
       searchKey: this.searchTemplateName,
       userID: this.currentUser.UID,     
       officeID: Number(this.myOfficeID),    
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList,
       databaseID: Number(this.databaseId),
       type:this.categoryType>0?this.categoryType:0, 
    }      
    this.taskService.getTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.TaskTemplatesList = response.data;
          if(this.categoryType==0){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
            //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
            this.FilteredTaskTemplatesList = this.TaskTemplatesList;
            //this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          }
          if(this.categoryType==1){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
           // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
            this.FilteredTaskTemplatesList = this.TaskTemplatesList;
            //this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          }
          if(this.categoryType==2){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
            //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
            this.FilteredTaskTemplatesList = this.TaskTemplatesList;
           // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          }
          if (this.TaskTemplatesList.length > 0) {
            this.ShowNoRecordFoundTaskTemplates = false;
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
          }   
          // this.TaskTemplatesList = response.data;                
          // if(this.TaskTemplatesList.length>0){
          //   this.ShowNoRecordFoundTaskTemplates=false;
          // }else{
          //   this.ShowNoRecordFoundTaskTemplates=true;
          //  }    
        }
        else {
          this.ShowNoRecordFoundTaskTemplates=true;
          this.TaskTemplatesList=[];          
          this.loaderService.hide();
        }
      }
      else {       
        this.ShowNoRecordFound=true;       
        this.loaderService.hide();
      }
    });
  }

  @Output() getMyTask = new EventEmitter<boolean>(); 

  MyTaskFunction(){   
    this.getMyTask.emit(false);  
  }

  showMyDrive(){
    this.showmyDrive = !this.showmyDrive
  }


  closeSaveAsTemplate(){
    this.taslTemplateID=0;
    this.addTemplateForm.reset();
    this.taskListFolderID=0;   
    this.dialog.closeAll();
  }

  closeMoveto(){
    this.dialog.closeAll();
   }

  timeout = null;

  searchTemplate(val) {
    if (val.length >= 2) {      
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.taskTemplateID=0;
          this.AttachChecked=false;
          this.AssigneeChecked=false;
          this.NotifyChecked=false;
          
          this.searchTemplateName=val;
          this.getTaskTemplates();
        }, 500);
      } else {
          
      }
    }else{
      this.searchTemplateName="";
        this.getTaskTemplates(); 
    }
  }

  

  //================Import Single Task ============//


  //=============== Import Single Task =================//

 ////=============== For Single Task =================//
 TaskIdForSingleTask:number=0;
 TaskTemplatesListForSingleTask:any=[]=[];
 TaskTemplatesListForSingleTaskFilter:any=[]=[];
 categoryTypeForSingleTask:number=0;
 taskTemplateIDForSingleTask:number=0;
 taskTitleForSingleTask:string="";
 selectedTemplate:any=[]=[];
 taskListIDforImportTask:number=0;
 showNew: boolean = false;
 showExisting: boolean = false;
 updateTaskTemplateTasksButton: boolean = false;
 filteredTaskCategoryList: any[] = [];
 categoryType: number = 0;
 taskTemplateNameForSingleTask:string="";
 transactionIDForTask:number=0;
 currentIndex: number = 0;
 typeIdForTask:number=0;

ImportTaskTemplate(templateRef: TemplateRef<any>) {
  this.dialog.open(templateRef, {
    panelClass: 'custom-modalbox',
  });
  this.categoryTypeForSingleTask=0;
  this.currentIndex=0;
  this.selectedTemplate=[];
  this.taskListIDforImportTask=0;
  this.getTaskTemplatesForSingleTask();
  this.selectedTaskCategoryID = 0;
  this.categoryType=0;
  this.searchTemplateName = "";
  this.getActiveTaskTemplateCategories();
}

 ImportTaskTemplateFromTaskList(templateRef: TemplateRef<any>,list:any) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;
    this.categoryTypeForSingleTask=0;
    this.currentIndex=0;
    this.selectedTemplate=[];
    this.taskListIDforImportTask = Number(list.taskListID);
    this.getTaskTemplatesForSingleTask();
    this.selectedTaskCategoryID = 0;
    this.categoryType=0;
    this.searchTemplateName = "";
    this.getActiveTaskTemplateCategories();
  }

  



onTaskListTabChangeForTaskImport($event) {
  this.selectedTemplate=[];
  this.selectedTaskCategoryID = 0;
  const textLabel = $event.value;
  const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;  
  this.categoryTypeForSingleTask=categoryValue;
  this.getTaskTemplatesForSingleTask();   
}

getTaskListThroughCategoryForTaskImport(e: any, i: any) {
  this.selectedTemplate=[];
  this.currentIndex = i 
  this.selectedTaskCategoryID = e;
  this.getTaskTemplatesForSingleTask();  
}

 //Checkbox Change detecting function
 getCheckboxValues(event, template) { 
  if (event.checked) {     
    this.selectedTemplate.push(template);     
  } else {
    let removeIndex = this.selectedTemplate.findIndex((itm) => itm === template);
    if (removeIndex !== -1) this.selectedTemplate.splice(removeIndex, 1);    
  }
  if(this.selectedTemplate.length == 0) {       
  }
 }


 async importTaskTemplates() {
  this.loaderService.show();
  var taskIdss=[];
  if (this.selectedTemplate.length > 0) {     
    for (let i = 0; i < this.selectedTemplate.length; i++) {      
      taskIdss.push(this.selectedTemplate[i].taskId);
    }
  }
  var taskListIDforImportTask=0;
  if(this.taskListIDforImportTask>0){
    taskListIDforImportTask=this.taskListIDforImportTask;
  }else{
    taskListIDforImportTask=0;
  }

  var ReqModel = {  
    taskIds: taskIdss,
    taskListID:Number(taskListIDforImportTask),
    transaction: {
      transactionID: this.transactionIDForTask,
      typeId: this.typeIdForTask
    },
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    databaseID: Number(this.databaseId),
    officeID: this.myOfficeID,
    officeIDList: this.OfficeIDList,
    keepAttached: false,//this.AttachChecked,
    keepAssignee: this.AssigneeChecked,
    keepNotify: this.NotifyChecked,
  }
  // return;
  this.spinner = true;
  const result = await this.taskService.importTaskFromTemplate(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner = false;
    this.loaderService.hide();     
    this.toastr.success("Task Imported successfully.", '', {
      timeOut: 3000,
    });
    this.closeImportTaskTemplate();
  }
  else {
    this.toastr.error("Task Import failed.", '', {
      timeOut: 3000,
    });
    this.spinner = false;
    this.loaderService.hide();
  }
}

closeImportTaskTemplate() {
  this.selectedTemplate=[];
  this.taskListFolderID = 0;
  this.taskListIDforImportTask=0;
  this.selectedTaskCategoryID = 0;
  this.searchTemplateName = "";
  this.categoryType=0;
  this.dialog.closeAll();
}


getTaskTemplatesForSingleTask() {
  this.ShowNoRecordFoundTaskTemplates = false;
  this.loaderService.show();
  var ReqModel = {
    transaction: {
      transactionID: this.transactionIDForTask,
      typeId: this.typeIdForTask
    },
    categoryID: Number(this.selectedTaskCategoryID),
    templateType: Number(this.categoryTypeForSingleTask),
    userID: this.currentUser.UID,
    officeID: Number(this.myOfficeID),
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList,
    databaseID: Number(this.databaseId)
  }
  this.taskService.getSingleTaskTemplates(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
        this.TaskTemplatesListForSingleTask = response.data.tasks;
        this.TaskTemplatesListForSingleTaskFilter = response.data.tasks;
        // if(this.categoryType==0){
        //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
        //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
        //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        // }
        // if(this.categoryType==1){
        //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
        //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
        //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        // }
        // if(this.categoryType==2){
        //   this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
        //   const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
        //   this.FilteredTaskTemplatesList = this.TaskTemplatesListForSingleTask.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        // }
        if (this.TaskTemplatesListForSingleTask.length > 0) {
          this.ShowNoRecordFoundTaskTemplates = false;
        } else {
          this.ShowNoRecordFoundTaskTemplates = true;
        }         
      }
      else {
        this.ShowNoRecordFoundTaskTemplates = true;
        this.TaskTemplatesListForSingleTask = [];
        this.loaderService.hide();
      }
    }
    else {
      this.TaskTemplatesListForSingleTask = [];
      this.ShowNoRecordFound = true;
      this.loaderService.hide();
    }
  });
}


searchTemplateForSingleTask(val) {
  if (val.length >= 2) {
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {    
      this.selectedTemplate=[];
      this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter(i => i.templateName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
      }, 500);
    } else {

    }
  } else {
    this.searchTemplateName = "";  
    this.getTaskTemplatesForSingleTask();    
  }
}


 // ======== Archived ============//

 currentTaskListArchived: number = 0;
 taskListSelectedArchived = false;
 taskListsArchived: any = [] = [];
 expandedIndexArchived: number = 0;
 taskListIDArchived: number = 0;



  //== For Archive Task List ====//
  archivedTaskList(tasklist: any) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to archive this task list?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: tasklist.taskListID,
            isArchived:true,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId),
          }
          //this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.archivedTaskList(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {
               // this.taskLists = [];               
                this.loaderService.hide();
                this.toastr.success('Task list Archived successfully.', '', {
                  timeOut: 3000,
                });
                this.gettaskls();
                this.getArchivedTaskLists();
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list Archived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list Archived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }


   //== For Archive Task List ====//
   UnarchivedTaskList(tasklist: any, tasklistfolder: any, index: number) {
    this.taskListSelectedArchived=true;
    this.taskListsArchived=[];
    const message = `Are you sure you want to unarchive this task list?`;
    const title = `Confirm`;
    const confirm = `Confirm`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var reqModel = {
            taskListID: tasklist.taskListID,
            isArchived:false,
            userID: this.currentUser.UID,
            officeID: this.myOfficeID,
            organizationID: Number(this.organizationId),
            officeIDList: this.OfficeIDList,
            databaseID: Number(this.databaseId),
          }
          this.expandedIndex = index;
          this.loaderService.show();
          this.taskService.archivedTaskList(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              if (this.responseHolder.status == this.statusConst.statusSuccess) {             
                this.loaderService.hide();
                this.toastr.success('Task list Unarchived successfully.', '', {
                  timeOut: 3000,
                });               
                this.gettaskls();             
                this.getArchivedTaskLists();
              } else {
                this.loaderService.hide();
                this.toastr.error('Task list Unarchived failed.', '', {
                  timeOut: 3000,
                });
              }
            } else {
              this.loaderService.hide();
              this.toastr.error('Task list Unarchived failed.', '', {
                timeOut: 3000,
              });
            }
          });
        }
      } catch (e) {
        Observable.throw(e);
      }
    });
  }

  getArchivedTaskLists(){
    var ReqModel = {      
      transaction: {
        transactionID: this.transactionID,
        typeId: this.typeId
       },
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId),
    }
    this.taskService.getArchivedTaskLists(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;     
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskListsArchived = response.data.taskLists;          
        }
        else {
          this.taskListsArchived = [];         
        }
      }
      else {
        this.taskListsArchived = [];       
      }
    });
  }


  getTaskLists1Archived(tasklist: any, index: number) {
    if(tasklist.id==1){
    if (this.currentTaskListArchived == index) {
      this.taskListSelectedArchived = !this.taskListSelectedArchived;
    } else {
      this.taskListSelectedArchived = true;
    }

     this.currentTaskListArchived = index;
     this.selectedRecordMoveToArray = [];
     this.selection.clear();
     this.showMoveToOption = false;
     this.expandedIndexArchived = index; 
     this.taskListsArchived=[];
    }

  }

  SingleTaskArchived:boolean=false;

  getTaskListsArchived(tasklist: any, index: number) {

    if(tasklist.id==1){
    if (this.currentTaskListArchived == index) {
      this.taskListSelectedArchived = !this.taskListSelectedArchived;
    } else {
      this.taskListSelectedArchived = true;
    }

    this.currentTaskListArchived = index;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;
    this.taskListsArchived = [];
    this.expandedIndexArchived = index;
    
    this.getArchivedTaskLists();  
    }
    if(tasklist.id==2){     
      this.IsAssignedToMe = false;
      this.IsAssignedToMyRole = false;
      this.IsCreatedByMe = false;
      this.IsAllTask = true;
      this.OpenTaskLists.emit(tasklist);  
    }  
  }

  OpenTaskListArchived(Tasklist: any) {
    this.taskListIDArchived = Tasklist.taskListID;
    this.selectedRecordMoveToArray = [];
    this.selection.clear();
    this.showMoveToOption = false;   
    Tasklist.name="Task List";
    this.OpenTaskLists.emit(Tasklist);  
    //this.getTaskByTaskListArchived();
  }

  AttachChecked:boolean=false;
  AssigneeChecked:boolean=false;
  NotifyChecked:boolean=false;


showOptions(event:MatCheckboxChange,data): void {
  if(data=="Attach"){
   this.AttachChecked=event.checked;
  }
  if(data=="Assignee"){
    this.AssigneeChecked=event.checked;
  }
  if(data=="Notify"){
    this.NotifyChecked=event.checked;
  }
}

onTaskListTabChange($event) {
  this.showAddTemp=false;
  this.addtaskTemplateName="";
  this.selectedTaskCategoryID = 0;  
  const textLabel = $event.value;
  const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
  this.categoryType = categoryValue;
  this.getTaskTemplates();  
}

getTaskListThroughCategory(e: any, i: any) {
  this.showAddTemp=false;
  this.addtaskTemplateName="";
  this.currentIndex = i
  this.selectedTaskCategoryID = e;
  this.getTaskTemplatesForTaskList();
}

FilteredTaskTemplatesList: any = [] = [];
addtaskTemplateName = "";
alltemp:any;
showAddTemp:boolean=false;
selectedTaskListFolderID:number=0;

ShowTemplateFromFolder(templateRef: TemplateRef<any>) {
  this.dialog.open(templateRef, {
    panelClass: 'task_template',
  });

  this.AttachChecked=false;
  this.AssigneeChecked=false;
  this.NotifyChecked=false;
  this.showAddTemp=false;
  this.taskListIDforAddTemplate = 0;
  this.categoryType=0;
  this.selectedTaskCategoryID = 0;
  this.selectedTaskListFolderID=0;

  this.searchTemplateName = "";
  this.addtaskTemplateName="";

  this.getTaskTemplates();    
  this.getActiveTaskTemplateCategories();
}


getTaskTemplatesForTaskList() {
  this.ShowNoRecordFoundTaskTemplates = false;
  this.loaderService.show();
  this.filteredTaskCategoryList=[];
  this.FilteredTaskTemplatesList =[];
  var ReqModel = {
    folderID: this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0,
    searchKey: this.searchTemplateName,
    userID: this.currentUser.UID,
    officeID: Number(this.myOfficeID),
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList,
    databaseID: Number(this.databaseId),
    type:this.categoryType>0?this.categoryType:0,
    //folderId:this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0
  }
  this.taskService.getActiveTaskTemplates(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
        this.TaskTemplatesList = response.data;
        if(this.categoryType==0){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
         // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;//.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          //this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if(this.categoryType==1){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
          //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;
          //this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if(this.categoryType==2){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
          //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;
          // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if (this.TaskTemplatesList.length > 0) {
          this.ShowNoRecordFoundTaskTemplates = false;
        } else {
          this.ShowNoRecordFoundTaskTemplates = true;
        }       
      }
      else {
        this.ShowNoRecordFoundTaskTemplates = true;
        this.TaskTemplatesList = [];
        this.FilteredTaskTemplatesList = [];
        this.loaderService.hide();
      }
    }
    else {
      this.ShowNoRecordFound = true;
      this.loaderService.hide();
    }
  });
}

searchTemplateForTaskList(val) {
  if (val.length >= 2) {      
    if (val != '') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.taskTemplateID=0;
        this.AttachChecked=false;
        this.AssigneeChecked=false;
        this.NotifyChecked=false;
        
        this.searchTemplateName=val;
        this.getTaskTemplatesForTaskList();
      }, 500);
    } else {
        
    }
  }else{
    this.searchTemplateName="";
    this.getTaskTemplatesForTaskList(); 
  }
}

templateSelected(temp){
  this.showAddTemp=true;
  this.alltemp = temp;
  this.addtaskTemplateName = temp.taskTemplateName;
}

async SelectTemplateForTaskList() {
  if(this.addtaskTemplateName==""){
    this.toastr.warning("Please add Tasklist Name.", '', {
      timeOut: 3000,
    });
    return;
  }

  this.loaderService.show();
  if(this.alltemp){
    var ReqModel = {
      "attachDetails": {
        "entityID": this.entityId,
        "cType": this.typeIdForTask,
        "name": this.name,
        "email": this.email,
        "entityTypeID": this.TypeIdDrp
      },
      taskListID:  Number(this.taskListIDforAddTemplate),
      taskListName: this.addtaskTemplateName,
      position: 0,
      folderID: 0,//this.selectedTaskListFolderID,
      taskTemplateID: this.alltemp.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: false,//this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
  }else{
    var ReqModel = {
      "attachDetails": {
        "entityID": this.entityId,
        "cType": this.typeIdForTask,
        "name": this.name,
        "email": this.email,
        "entityTypeID": this.TypeIdDrp
      },
      taskListID:  Number(this.taskListIDforAddTemplate),
      taskListName: this.addtaskTemplateName,
      position: 0,
      folderID: 0,//this.selectedTaskListFolderID,
      taskTemplateID: this.alltemp?.taskTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
  }
  // return;
  this.spinner = true;
  const result = await this.taskService.addTaskList(ReqModel).toPromise();
  if (result.status === this.statusConst.statusSuccess) {
    this.spinner = false;
    this.loaderService.hide();
    this.gettaskls();
    this.taslTemplateID = 0;
    this.toastr.success("Task Imported successfully.", '', {
      timeOut: 3000,
    });
    this.addtaskTemplateName = "";
    this.alltemp = null;
    this.closeTemplate();
    this.addtaskTemplateName = "";
    this.alltemp = null;
  }
  else {
    this.toastr.error("Task Import failed.", '', {
      timeOut: 3000,
    });
    this.spinner = false;
    this.loaderService.hide();
    this.addtaskTemplateName = "";
    this.alltemp = null;
  }   
}

getTaskTemplatesForAddTaskList() {
  this.ShowNoRecordFoundTaskTemplates = false;
  this.loaderService.show();
  this.filteredTaskCategoryList=[];
  this.FilteredTaskTemplatesList =[];
  var ReqModel = {
    folderID: this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0,
    searchKey: this.searchTemplateName,
    userID: this.currentUser.UID,
    officeID: Number(this.myOfficeID),
    organizationID: Number(this.organizationId),
    officeIDList: this.OfficeIDList,
    databaseID: Number(this.databaseId),
    type:this.categoryType>0?this.categoryType:0,
    //folderId:this.selectedTaskCategoryID>0?this.selectedTaskCategoryID:0
  }
  this.taskService.getTaskTemplates(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.responseHolder = response;
      this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
        this.TaskTemplatesList = response.data;
        if(this.categoryType==0){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
         // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;
          //this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if(this.categoryType==1){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
          //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;
          // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if(this.categoryType==2){
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
          //const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
          this.FilteredTaskTemplatesList = this.TaskTemplatesList;
          // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
        }
        if (this.TaskTemplatesList.length > 0) {
          this.ShowNoRecordFoundTaskTemplates = false;
        } else {
          this.ShowNoRecordFoundTaskTemplates = true;
        }       
      }
      else {
        this.ShowNoRecordFoundTaskTemplates = true;
        this.TaskTemplatesList = [];
        this.FilteredTaskTemplatesList = [];
        this.loaderService.hide();
      }
    }
    else {
      this.ShowNoRecordFound = true;
      this.loaderService.hide();
    }
  });
}

MailToAssignee(list) {
  var ReqModel = {
     taskListID: list.taskListID,        
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),
     officeID: this.myOfficeID,
     officeIDList: this.OfficeIDList,
     databaseID: Number(this.databaseId)
   };
   this.loaderService.show();
   this.taskService.resendTasklistURL(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;
       this.loaderService.hide();
       if (this.responseHolder.status == this.statusConst.statusSuccess) { 
         this.toastr.success('Mail sent to assignee successfully.', '', {
           timeOut: 4000,
         });                      
         this.loaderService.hide();
         this.gettaskls();                 
       } else {
         this.toastr.error('Failed to send mail to assignee.', '', {
           timeOut: 4000,
         }); 
         this.loaderService.hide();
       }
     } else {
       this.toastr.error('Failed to send mail to assignee.', '', {
         timeOut: 4000,
       }); 
       this.loaderService.hide();
     }
   });
}


}

